export const showNumberIndex = true; //to be moved to graphQl later
